module.exports = __webpack_public_path__ + "static/media/diversity.53e15625.jpeg";